<template>
  <div class="batch-import-job-step">
    <i
      class="pi mr-1"
      :class="{
        'pi-spin': state === 'IN_PROGRESS',
        'pi-spinner': state === 'IN_PROGRESS',
        'pi-check-circle': state === 'COMPLETE',
        'pi-times': state === 'ERROR',
      }"
    />
    {{ label }}
  </div>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';

import { BatchImportStepState } from '@/model';

const props = defineProps({
  state: {
    type: String as PropType<BatchImportStepState>,
    default: 'NOT_STARTED',
  },
  label: {
    type: String,
    default: '',
  },
});

const { state } = toRefs(props);
</script>

<style>
.batch-import-job-step {
  font-size: 16px;
  font-weight: bold;
}
</style>
